import React from "react";
import { useForm } from "react-final-form";
import { SelectField, SwitchField } from "@syos-music/form";
import {
  InstrumentTypeSelectField,
  MaterialColorSelectField,
} from "@syos-music/instruments";
import { Product } from "@syos-music/products";

import { Grid, MenuItem } from "@mui/material";

const { OriginalsType, OriginalsTipOpeningSelectField } =
  Product.displayModes.originalsMouthpiece;

export default function OptionsField({ isOrderPaid, cartItem, name }) {
  const { instrument } = cartItem.product.defaultOptions;

  const form = useForm();
  const instrumentType = form.getFieldState(`${name}.instrumentType`)?.value;
  const originalsType = form.getFieldState(`${name}.originalsType`)?.value;
  const addLigature = form.getFieldState(`${name}.addLigature`)?.value;

  return (
    <Grid container>
      <Grid item xs={12} sm={6}>
        <InstrumentTypeSelectField
          instrument={instrument}
          name={`${name}.instrumentType`}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SelectField name={`${name}.originalsType`} label="Originals">
          {OriginalsType.originalsTypes.map((originalsType) => (
            <MenuItem key={originalsType} value={originalsType}>
              <OriginalsType originalsType={originalsType} />
            </MenuItem>
          ))}
        </SelectField>
      </Grid>

      <Grid item xs={12} sm={6}>
        <OriginalsTipOpeningSelectField
          name={`${name}.tipOpening`}
          instrument={instrument}
          instrumentType={instrumentType}
          originalsType={originalsType}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <MaterialColorSelectField
          name={`${name}.mouthpieceColor`}
          label="Couleur bec"
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <SwitchField
          name={`${name}.addLigature`}
          label="Ajouter une ligature"
          sx={{ mt: 2 }}
          disabled
          helperText="Cette options n'est plus disponible, vous devez ajouter les ligatures & couvre-becs manuellement."
        />
      </Grid>

      {addLigature && (
        <Grid item xs={12} sm={6}>
          <MaterialColorSelectField
            name={`${name}.ligatureColor`}
            label="Couleur ligature"
          />
        </Grid>
      )}
    </Grid>
  );
}
